import moment from "../moment/moment";

const formatTimestamp = (str) => {
  return moment(str).local().format("L, LT");
};

const formatDateDMY = (value) =>
  value ? moment(value).local().format("DD/MM/YYYY") : "—";

const formatUnixDMY = (seconds) =>
  seconds ? moment(seconds * 1000).format("DD/MM/YYYY") : "—";

export { formatTimestamp, formatDateDMY, formatUnixDMY };
